import { Controller } from "@hotwired/stimulus";

/** Expand/collapse "What the Buyer will see" with animated height (grid 0fr/1fr). */
export default class extends Controller {
  static targets = ["panel", "trigger", "icon", "content"];

  connect() {
    if (!this.supportsInert()) return;
    if (this.isPanelClosed() && this.hasContentTarget) {
      this.contentTarget.inert = true;
    }
  }

  supportsInert() {
    return typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
  }

  isPanelClosed() {
    return this.panelTarget.classList.contains("grid-rows-[0fr]");
  }

  toggle() {
    const opening = this.isPanelClosed();

    const canInert = this.supportsInert();

    if (opening) {
      this.panelTarget.classList.remove("grid-rows-[0fr]");
      this.panelTarget.classList.add("grid-rows-[1fr]");
      this.triggerTarget.setAttribute("aria-expanded", "true");
      this.triggerTarget.classList.add("rounded-b-none");
      if (this.hasIconTarget) this.iconTarget.classList.add("rotate-180");
      if (canInert && this.hasContentTarget) this.contentTarget.inert = false;
    } else {
      this.panelTarget.classList.remove("grid-rows-[1fr]");
      this.panelTarget.classList.add("grid-rows-[0fr]");
      this.triggerTarget.setAttribute("aria-expanded", "false");
      this.triggerTarget.classList.remove("rounded-b-none");
      if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180");
      if (canInert && this.hasContentTarget) this.contentTarget.inert = true;
    }
  }
}
